import React, { Component } from "react";
import { connect } from "react-redux";

import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { toggleDemoVideoPlayerModal } from "./../../../store/reducers/generalActions";
import VideoPlayer from "./../../common/videoplayer";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");
    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  hasPermission = (perm) => {
    if (this.props.isdefaultadmin) {
      return true;
    }
    if (this.props.userpermissions.includes(perm)) {
      return true;
    }
    return false;
  };

  handleDemoVideo = (e) => {
    e.preventDefault();
    this.props.dispatch(toggleDemoVideoPlayerModal());
  };

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    return (
      <React.Fragment>
        <VideoPlayer />
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            {this.hasPermission("dashboard") && (
              <li>
                <Link to="/enterprise/dashboard" className="waves-effect">
                  <i className="ri-dashboard-line"></i>
                  {/* <span className="badge badge-pill badge-success float-right">
                  3
                </span> */}
                  <span className="ml-1">Dashboard</span>
                </Link>
              </li>
            )}
            {this.hasPermission("members") && (
              <li>
                <Link to="/enterprise/members" className="waves-effect">
                  <i className="ri-building-4-line"></i>
                  <span className="ml-1">Members</span>
                </Link>
              </li>
            )}
            {this.hasPermission("task-library") && (
              <li>
                <Link to="/enterprise/tasks-library" className="waves-effect">
                  <i className="ri-file-edit-fill"></i>
                  <span className="ml-1">Tasks Library</span>
                </Link>
              </li>
            )}
            <li>
              <Link to="/enterprise/my-tasks" className=" waves-effect">
                <i className="ri-task-line"></i>
                <span className="ml-1">My Tasks</span>
              </Link>
            </li>
            {this.hasPermission("content-library") && (
              <li>
                <Link to="/enterprise/content-library" className="waves-effect">
                  <i className="ri-todo-line"></i>
                  <span className="ml-1">Content Library</span>
                </Link>
              </li>
            )}
            {this.props.user?.enterpriseId?.enableCourseFeature == 1 &&
              this.props.user?.roleId.name &&
              this.props.user?.roleId?.name.toLowerCase() == "admin" && (
                <li>
                  <Link to="/enterprise/courses" className="waves-effect">
                    <i className="ri-todo-line"></i>
                    <span className="ml-1">Courses</span>
                  </Link>
                </li>
              )}
            {this.props.user?.enterpriseId?.enableCompanyInfoFeature == 1 &&
              this.props.user?.roleId.name &&
              this.props.user?.roleId?.name.toLowerCase() == "admin" && (
                <li>
                  <Link to="/enterprise/company-info" className="waves-effect">
                    <i className="ri-information-line"></i>
                    <span className="ml-1">Company Info</span>
                  </Link>
                </li>
              )}
            {this.hasPermission("reports") && (
              <li>
                <Link to="/enterprise/reports" className="waves-effect">
                  <i className="ri-price-tag-3-fill"></i>
                  <span className="ml-1">Reports</span>
                </Link>
              </li>
            )}
            {this.hasPermission("roles") && (
              <li>
                <Link to="/enterprise/roles" className="waves-effect">
                  <i className="ri-user-5-fill"></i>
                  <span className="ml-1">User Roles</span>
                </Link>
              </li>
            )}
            {this.hasPermission("groups") && (
              <li>
                <Link to="/enterprise/groups" className="waves-effect">
                  <i className="ri-group-fill"></i>
                  <span className="ml-1">Groups</span>
                </Link>
              </li>
            )}
            {this.hasPermission("surveys") && (
              <li>
                <Link to="/enterprise/surveys" className="waves-effect">
                  <i className="ri-building-4-line"></i>
                  <span className="ml-1">Surveys</span>
                </Link>
              </li>
            )}
            {this.hasPermission("reading-topics") && (
              <li>
                <Link to="/enterprise/reading-topics" className=" waves-effect">
                  <i className="ri-book-2-fill"></i>
                  <span className="ml-1">Reading Topics</span>
                </Link>
              </li>
            )}
            <li>
              <Link to="/enterprise/help" className=" waves-effect">
                <i className="ri-tools-fill"></i>
                <span className="ml-1">Help</span>
              </Link>
            </li>
            <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ri-list-settings-fill"></i>
                <span className="ml-1">Configurations</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                {this.hasPermission("groups") && (
                  <li>
                    <Link to="/enterprise/config/pronunciation">
                      Pronunciation
                    </Link>
                  </li>
                )}
              </ul>
            </li>

            {/* {this.props.user?.roleId.name &&
              this.props.user?.roleId?.name.toLowerCase() == "admin" && (
                <li>
                  <Link
                    to="/demovideo"
                    onClick={this.handleDemoVideo}
                    className=" waves-effect"
                  >
                    <i className="ri-video-fill"></i>
                    <span className="ml-1">Demo Video</span>
                  </Link>
                </li>
              )} */}

            {/* <li>
              <Link to="/#" className="has-arrow waves-effect">
                <i className="ri-share-line"></i>
                <span className="ml-1">Multi Level</span>
              </Link>
              <ul className="sub-menu" aria-expanded="true">
                <li>
                  <Link to="/#">Level 1.1</Link>
                </li>
                <li>
                  <Link to="/#" className="has-arrow">
                    Level 1.2
                  </Link>
                  <ul className="sub-menu" aria-expanded="true">
                    <li>
                      <Link to="/#">Level 2.1</Link>
                    </li>
                    <li>
                      <Link to="/#">Level 2.2</Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li> */}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    userpermissions: state.auth.user.roleId.permissions || [],
    isdefaultadmin: state.auth.user.isDefaultAdmin,
    user: state.auth.user,
  };
};

export default withRouter(connect(mapStatetoProps)(SidebarContent));
